import axios from "axios";

const accessJWTApi = `${process.env.REACT_APP_API_ROOT_URL}/token`;

const getNewAccessJWT = async () => {
	window.sessionStorage.removeItem("accessJWT");
	const Authorization = window.localStorage.getItem("refreshJWT");

	if (Authorization) {
		const { data } = await axios.get(accessJWTApi, {
			headers: {
				Authorization,
			},
		});

		data.accessJWT &&
			window.sessionStorage.setItem("accessJWT", data.accessJWT);

		return data;
	}
	return { status: "error", message: "logout user" };
};

export const requestApi = async (axiosInfo, sendAuth) => {
	try {
		if (sendAuth) {
			axiosInfo = {
				...axiosInfo,
				headers: {
					Authorization: window.sessionStorage.getItem("accessJWT"),
				},
			};
		}

		const { data } = await axios(axiosInfo);
		return data;
	} catch (error) {
		if (error.response?.status === 401) {
			return { status: "error", message: "logout user" };
		}

		if (
			error.response?.status === 403 &&
			error.response?.data?.message === "jwt expired"
		) {
			const { accessJWT } = await getNewAccessJWT();

			if (accessJWT) {
				return requestApi(axiosInfo, sendAuth);
			}
		}

		return error.response.data || { status: "error", message: error.message };
	}
};
